/* global G */
import submit from 'app/_shared/action/favorite/submit'
import find from 'lib/sequence/component/children/find'
import { checked } from 'lib/sequence/component/state/checked'

/**
 * If the field "Add to favorites" is checked, adds the registered device to the user's list of
 * favorites.
 *
 * @param {Gaia.AppModule.Spec} obj the current module
 * @return {function(...[*]): Promise<*[]>}
 */
const submitFavorite = obj => async (...args) => {
  const itemKey = obj[G.MODEL][G.STATE][G.REF]
  const actionComponent = obj[G.STATE][G.ACTION][G.COMPONENT]
  const { addToFavorites } = find(actionComponent)

  checked(addToFavorites)
    && await submit(obj)(null)([itemKey, { type: 'serviceitem' }, ...args])

  return args
}

export default submitFavorite
